import { render } from "./SchoolHeader.vue?vue&type=template&id=561e01e7&scoped=true"
import script from "./SchoolHeader.vue?vue&type=script&lang=js"
export * from "./SchoolHeader.vue?vue&type=script&lang=js"

import "./SchoolHeader.vue?vue&type=style&index=0&id=561e01e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561e01e7"]])

export default __exports__